import React, {useState, useEffect} from 'react';
import {useForm} from 'react-hook-form';
import FormService from "../../../../services/FormsService";
import CUFormService from "../../../../services/CUFormService";
import { LOGO_MARIANE_IMG} from '../../../../constants'
import moment from "moment";
import {connect} from "react-redux";


const TemplateCollectivHeader = (props)=>{

    //const [demInfo, setDemInfo] = useState({name:'', email:''});
    const [entity, setentity] = useState({name:'', email:'', phone:'', cp:'', address:'', address2:''});
    const [code, setCode] = useState('0000000');
    const [imgBase64, setImgBase64] = useState();
    const cuFormService = new CUFormService();
    const formService = new FormService();
    const { register, handleSubmit, watch, errors } = useForm();
    const [annexes, setAnnexes] = useState();
    const [headingInfo, setHeadingInfo] = useState();
    const [formRefData, setFormRefData] = useState();

    useEffect(()=>{
        //console.log('doctype', props.docType)
        moment.locale('fr');
        setentity(cuFormService.getEntityInfo())
        setAnnexes(formService.getEntityAnnexes())
        setHeadingInfo(formService.getEntityHeadingInfo())
        //console.log("heading-info ",formService.getEntityHeadingInfo())
    }, [])

    useEffect( ()=>{

        if(entity && entity.id){
            formService.getCode(entity.id, String(props.doctype).toLowerCase())
                .then(result=>{
                setCode(result);
            })
        }
    },[entity])

    useEffect(()=>{
        /// laisser pour recup code et img !!
    }, [code])


    return (
                <table className={"ue-header-table"} style={{"width":"100%"}}>
                    <tbody>
                    <tr>
                        <td className={"text-center"}
                            style={{"width":"50%", "textAlign":"center", "verticalAlign":"middle!important", "paddingTop": "30px"}}>
                            <img   src={ (props.logob64)?props.logob64:LOGO_MARIANE_IMG}
                                   alt={ (entity?.logo && entity?.logo !== '')?"collectivite_logo":"logo_rf"}
                                   style={{maxWidth:"170px",maxHeight:"100px"}}
                            />
                            <div style={{"minWidth": "200px"}}>
                                <div className={"ue-block-mark"}>
                                    <h2 style={{"fontWeight":"400"}}>{(headingInfo?.header_name && headingInfo?.header_name!=='')?headingInfo?.header_name:entity.name}</h2>

                                </div>
                            </div>
                        </td>
                        <td className={"text-right ue-cellule_border"}
                            style={{"verticalAlign":"top", "width":"50%", "borderColor": "#ced4d9", "borderStyle": "solid", "padding": "10px"}}>
                                <h3 className={"ue-font-weight-7"} >
                                    Dossier n° <span id={"formRefCode"}>{code}</span>
                                </h3>
                                <br/>
                                <br/>
                                <br/>
                                Date de dépôt : le {moment().format('L')}
                                <br/>
                            {(props.doctype !=='ru')?
                                (annexes?.delivrance_txt && annexes?.delivrance_txt !=='')?annexes?.delivrance_txt:"Délivré par le Maire au nom de la commune"
                                :<br/>
                            }

                        </td>
                    </tr>
                    </tbody>
                </table>

    )
}

export default TemplateCollectivHeader
